import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  agendamentos: [],
  agendamentoSelecionado: {},
  rotas: [],
  operadores: [],
  ramais: [{}],
  operador: {},
  departamentos: [],
  departamento: {},
  gruposDeRotas: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
